/* @ngInject */
const autocomplete = (
  autocompleteRequest
) => {
  const self = {}

  self.request = autocompleteRequest

  return self
}
export default autocomplete



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/autocomplete/services/autocomplete.service.js